<!--
/*******************************************************************************
*@ 컴포넌트명   : PersonalInfoTab1.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [개인] : 기본정보
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form">
    <!-- 고객명 -->
    <div class="form-row">
      <input-text
        ref="ovsesCustOcntryName"
        id="ovsesCustOcntryName"
        :value="data.ovsesCustOcntryName"
        label-i18n="MPRS-01-01-03-06"
        disabled
      />
    </div>
    <!-- 자택 전화번호 -->
    <div class="form-row">
      <input-text
        ref="owhusTelno"
        id="owhusTelno"
        type="tel"
        :value.sync="data.owhusTelno"
        label-i18n="MPRS-01-01-03-07"
        placeholder="MPRS-01-01-03-07"
        :maxlength="16"
        :err-msg-param="{filed:$t('MPRS-01-01-03-07'), max:16}"
        numeric
      />
    </div>
    <!-- 휴대폰 번호 : 인도, 베트남, 캄보디아-->
    <div
      v-show="siteCode != $config.SITECODE_OGIND && siteCode != $config.SITECODE_OGHCM && siteCode != $config.SITECODE_OGCBD"
      class="form-row"
    >
      <input-text
        ref="cphnNo"
        id="cphnNo"
        type="tel"
        :value.sync="data.cphnNo"
        label-i18n="MPRS-01-01-03-08"
        placeholder="MPRS-01-01-03-08"
        :maxlength="16"
        :err-msg-param="{filed:$t('MPRS-01-01-03-08'), max:16}"
        :required="`${$config.SITECODE_OGAUC}|${$config.SITECODE_OGMMR}`"
        numeric
      />
    </div>
    <!-- 이메일 주소 : 베트남, 캄보디아 제외 -->
    <div
      v-show="siteCode != $config.SITECODE_OGHCM && siteCode != $config.SITECODE_OGCBD"
      class="form-row"
    >
      <div class="item-tit">
        {{ /*이메일 주소*/ $t("MPRS-01-01-03-09") }}
        <required />
      </div>
      <div class="item-desc">
        <div class="form-text-field">
          <div class="input-text-field group-email">
            <input-text
              ref="emailId"
              id="emailId"
              :value.sync="data.emailId"
              placeholder="MCOP-01-01-03-12"
              :maxlength="30"
              :err-msg-param="{filed:$t('MCOP-01-01-03-12'), max:30}"
              :required="`${$config.SITECODE_OGAUC}|${$config.SITECODE_OGMMR}|${$config.SITECODE_OGIND}`"
              toLowerCase
            />
            <span class="email-at">@</span>
            <input-text
              ref="emailAddress"
              id="emailAddress"
              :value.sync="data.emailAddress"
              :maxlength="30"
              :err-msg-param="{filed:$t('MCOP-01-01-03-12'), max:30}"
              :required="`${$config.SITECODE_OGAUC}|${$config.SITECODE_OGMMR}|${$config.SITECODE_OGIND}`"
              toLowerCase
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 우편물 수신 : 인도 제외 -->
    <div v-show="siteCode != $config.SITECODE_OGIND" class="form-row">
      <div class="item-tit">{{ /*우편물 수신*/ $t("MPRS-01-01-06-06") }}</div>
      <div class="item-desc">
        <radio-box
          id="postSendAreaDstcd"
          ref="postSendAreaDstcd"
          :data-list="codeInfo.postSendAreaDstcd.code"
          :value.sync="data.postSendAreaDstcd"
        />
      </div>
    </div>
    <!-- 거래 Statement 우편발송 여부 : 오클랜드 표시 -->
    <div v-show="siteCode === $config.SITECODE_OGAUC" class="form-row">
      <radio-box
        id="postSendYn"
        ref="postSendYn"
        :data-list="codeInfo.postSendYn.code"
        :value.sync="postSendYn"
        :title-i18n="codeInfo.postSendYn.name"
        :required="`${$config.SITECODE_OGAUC}`"
      />
      <div
        class="info info-etc"
      >※ {{/*조회 > 거래내역조회 > Statement조회에서 조회 후 인쇄할 수 있습니다.*/ $t("MPRS-01-01-06-12") }}</div>
    </div>
    <!-- Statement 우편수신서비스 신청 -->
    <div v-show="siteCode === $config.SITECODE_OGAUC && data.postSendYn=='1'" class="form-row">
      <div class="item-tit">
        {{ /*Statement 우편수신서비스 신청*/ $t("MPRS-01-01-06-15") }}
        <required />
      </div>
      <div class="item-desc">
        <vuelidate-form :validator="$v.data.isPostSendYnAgree">
          <div class="form-check">
            <input
              type="checkbox"
              ref="isPostSendYnAgree"
              id="isPostSendYnAgree"
              class="form-check-input"
              v-model="data.isPostSendYnAgree"
            />
            <label
              for="isPostSendYnAgree"
              class="form-check-label"
            >{{ /*우편수신 동의*/ $t("MPRS-01-01-06-16") }}</label>
          </div>
        </vuelidate-form>
        <div class="info info-etc-col">
          <p>※ {{ /*다음달부터 요청하신 수신지로 Statement를 받아 보시게 됩니다.*/ $t("MPRS-01-01-06-17") }}</p>
          <p>※ {{ /*우편물 수신지의 주소가 맞는지 확인해주시고, 주소가 올바르지 않을 경우 영업점 변경 요청 후 해당 서비스를 신청하시기 바랍니다.*/ $t("MPRS-01-01-06-18") }}</p>
          <p>※ {{ /*우편으로 수신을 요청한 경우에 고객주소가 외국이거나 주소가 불분명한 경우는 발송이 되지 않을 수도 있습니다.*/ $t("MPRS-01-01-06-19") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Required from "@/components/template/Required";
import { required } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["data"],
  components: {
    Required,
  },
  validations: {
    data: {
      isPostSendYnAgree: {
        required: function (val, paramObj) {
          if (this.siteCode !== this.$config.SITECODE_OGAUC) return true;
          if (this.postSendYn !== "1") return true;

          const isPostSendYnAgree = paramObj.isPostSendYnAgree === true;
          return required(isPostSendYnAgree ? isPostSendYnAgree : undefined);
        },
      },
    },
  },
  data() {
    return {
      codeInfo: {
        postSendAreaDstcd: {
          name: "MPRS-01-01-06-06", //우편물 수신
          code: [
            {
              value: "1",
              text: "1_우편발송지구분코드", //자택
            },
            {
              value: "2",
              text: "2_우편발송지구분코드", //회사
            },
          ],
        },
        postSendYn: {
          name: "MPRS-01-01-06-09", //거래 Statement 우편발송 여부
          code: [
            {
              value: "1",
              text: "1_우편발송여부", //우편수신
            },
            {
              value: "0",
              text: "0_우편발송여부", //우편수신거부
            },
          ],
        },
      },
    };
  },
  computed: {
    ...mapFields(["siteCode"]),
    postSendYn: {
      get() {
        return this.data.postSendYn;
      },
      set(value) {
        this.data.postSendYn = value;

        if (value == "0") {
          this.data.isPostSendYnAgree = false;
        }
      },
    },
  },
  methods: {
    touch() {
      this.$v.$touch();
      this.$refs.owhusTelno.$v.$touch();
      this.$refs.cphnNo.$v.$touch();
      this.$refs.emailId.$v.$touch();
      this.$refs.emailAddress.$v.$touch();
      this.$refs.postSendAreaDstcd.$v.$touch();
      this.$refs.postSendYn.$v.$touch();
    },
  },
};
</script>